import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useParams } from 'react-router-dom';
import MainLayout from '../../layouts/MainLayout';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckDouble, faList, faPlus, faPlusSquare, faQrcode } from '@fortawesome/free-solid-svg-icons';
import './AssetTagger.css';
import assettaggerimage from '../../assets/pageimages/AssetTagger.webp';

function AssetTaggerHome() {

  return (
    <MainLayout>
      <div>
        <h2 className='text-lg mt-1 mx-8 border-b border-b-gray-300 text-white'>AssetTagger</h2>
      </div>
      <div className="main-content">
        <div className="top-section top-section mt-4 ml-2 mr-0 border border-b-gray-300">
          <div className="button-links flex align-middle justify-center bg-gray-500">
            <div className="bottom-buttons-box"><Link to="/assettagger-create" className="top-button-link"><FontAwesomeIcon icon={faPlusSquare} className="assettagger-bottomlink-style" />Create Assest</Link></div>
            <div className="bottom-buttons-box"><Link to="/assettagger-list" className="top-button-link"><FontAwesomeIcon icon={faList} className="assettagger-bottomlink-style" />Asset List</Link></div>
            <div className="bottom-buttons-box"><Link to="/assettagger-scan" className="top-button-link"><FontAwesomeIcon icon={faQrcode} className="assettagger-bottomlink-style" />Scan</Link></div>
            <div className="bottom-buttons-box"><Link to="/assettagger-audit" className="top-button-link"><FontAwesomeIcon icon={faCheckDouble} className="assettagger-bottomlink-style" />Audit</Link></div>
          </div>
        </div>
        <div className="image-container">
          <div className="relative inset-0 flex border border-b-gray-300">
            <img id="assettagger-id" src={assettaggerimage} alt="AssetTagger Image" />
          </div>
        </div>
      </div>
    </MainLayout>
  );
}

export default AssetTaggerHome;
